/* eslint-disable */
import * as React from "react";
import OrbitIcon from "../Icon";
export default function Airplane(props) {
  var color = props.color,
      size = props.size,
      customColor = props.customColor,
      className = props.className,
      dataTest = props.dataTest,
      ariaHidden = props.ariaHidden,
      ariaLabel = props.ariaLabel,
      reverseOnRtl = props.reverseOnRtl;
  return React.createElement(OrbitIcon, {
    viewBox: "0 0 24 24",
    size: size,
    color: color,
    customColor: customColor,
    className: className,
    dataTest: dataTest,
    ariaHidden: ariaHidden,
    reverseOnRtl: reverseOnRtl,
    ariaLabel: ariaLabel
  }, React.createElement("path", {
    d: "M10.208 9.55A476.9 476.9 0 0 0 7.85 7.33c-.397-.394-.708-.608-.597-.825.111-.218.242-.202 1.1-.237.859-.035.804.027 1.315.327.51.3 4.22 2.824 4.299 2.997.079.172-.074.19-.168.203-.094.012-2.94.054-3.137.046-.198-.009-.342-.182-.453-.292zM20.67 11.9c0 .584-.773 1.356-2.41 1.35-1.107.01-2.328.01-3.664.003a.61.61 0 0 0-.293.066 3086.9 3086.9 0 0 1-4.468 4.094c-.345.311-.477.31-1.162.314-.685.005-.658 0-1.404 0-.24 0-.601-.028-.63-.314-.03-.286.386-.69.63-.959.244-.268 1.994-2.143 2.62-2.81.124-.133.148-.21.15-.25 0-.086-.06-.167-.204-.167l-4.408.023c-.37.036-.652-.161-.796-.484A9603.258 9603.258 0 0 0 3.465 9.88a2.264 2.264 0 0 1-.14-.51c-.036-.22.111-.463.56-.47.449-.006.925.118 1.16.358L6.164 10.4c.127.104.16.116.311.12 7.148-.168 11.263-.178 12.345-.032 1.622.22 1.85.827 1.85 1.412z"
  }));
}